<template>
  <div>
    <Header :isactive='6' :ischunrk='true' :key="new Date().getTime()"/>
    <div style="height: 60px;"></div>
    <div id="banner">
      <img src="@/assets/image/banner-rule.jpg" alt="">
    </div>
    <div id="contact-us">
      <div class="us-content">
        <div class="title-content">
          <p class="trans">PRIVACY POLICY STATEMENT</p>
          <p class="title">隐私权政策声明</p>
        </div>
        <div class="us-list">

          <p class="text-item">本隐私权政策声明说明了在您访问西安西安优我科华视觉科技有限公司（以下简称优我科华）的合作伙伴网站时，我们所采取的相关隐私权保护政策。</p>
          <p class="text-item">
            当您通过网络浏览器访问网络时，为了投放与您相关且符合您的兴趣的广告，我们会使用您在优我科华合作伙伴网站中的相关浏览信息,并且我们会在为您提供广告的过程中在您的浏览器里放置一个Cookie。Cookie是一个文本文件，由一系列随机数字和字母组成吗，可用作您的浏览器的匿名标识符，但不会用于识别您的身份。我们使用Cookie、网络信标或其他技术记录下列信息：您的浏览器页面上展示了哪些广告，您点击了哪些广告，以及您在我们的合作伙伴网站中执行了哪些操作。Cookie可以帮助我们向您投放更具相关性并且更实用的广告。

          </p>
          <p class="text">
            优我科华尊重并保护所有使用优我科华合作伙伴网站用户的个人隐私权。为了给您提供更准确、更有个性化的服务，优我科华会按照本隐私权政策的规定使用和披露您的个人信息。但优我科华将以高度的勤勉、审慎义务对待这些信息。除本隐私权政策另有规定外，在未征得您事先许可的情况下，优我科华不会将这些信息对外披露或向第三方提供。优我科华会不时更新本隐私权政策。
          </p>
          <p class="title">一、适用范围</p>
          <p class="text-item">（1）在您注册优我科华账户时，您根据优我科华要求提供的个人注册信息；</p>
          <p class="text">
            （2）在您访问优我科华合作伙伴网络时，优我科华自动接收并记录的您的浏览器和计算机上的信息，包括但不限于您的IP地址、浏览器的类型、使用的语言、访问日期和时间、软硬件特征信息及您需求的网页记录等数据。</p>
          <p class="title">二、信息使用</p>
          <p class="text-item">（1） 优我科华不会向任何无关第三方提供、出售、出租、分享或交易您的个人信息，除非：（a)本隐私权政策另有规定；(b)事先得到您的许可；
            ©第三方和优我科华（含优我科华关联公司）单独或共同为您提供服务，且在该服务结束后，该等第三方将被禁止访问其以前能够访问的所有这些资料。</p>
          <p class="text">（2）
            为服务用户的目的，优我科华可能通过使用您的个人信息，向您提供您感兴趣的信息，包括但不限于向您进行广告展示，或者与优我科华合作伙伴共享信息以便他们向您发送有关其产品和服务的信息（后者需要您的事先同意）。</p>
          <p class="title">三、信息披露</p>
          <p class="text-item">在如下情况下，优我科华将依据您的个人意愿或法律的规定全部或部分的披露您的个人信息：</p>
          <p class="text-item">（1） 经您事先同意，向第三方披露；</p>
          <p class="text-item">（2） 如您是适格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷；</p>
          <p class="text-item">（3） 根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；</p>
          <p class="text-item">（4） 如您出现违反中国有关法律、法规或者优我科华服务协议或相关规则的情况，需要向第三方披露；</p>
          <p class="text-item">（5） 为提供您所要求的产品和服务，而必须和第三方分享您的个人信息；</p>
          <p class="text">（6） 其它优我科华根据法律、法规或者网站政策认为合适的披露。</p>
          <p class="title">四、信息存储和交换</p>
          <p class="text">优我科华收集的有关您的信息和资料将保存在优我科华及（或）其关联公司的服务器上，这些信息和资料可能传送至您所在国家、地区或优我科华收集信息和资料所在地的境外并在境外被访问、存储和展示。
          </p>
          <p class="title">五、Cookie的使用</p>
          <p class="text-item">（1）
            在您未拒绝接受优我科华的情况下，优我科华会在您的计算机上设定或取用cookies，以便您能登录或使用依赖于cookies的优我科华平台服务或功能。优我科华使用cookies可为您提供更加周到的个性化服务,包括推广服务。
          </p>
          <p class="text-item">（2）
            您有权选择接受或拒绝接受cookies。您可以通过修改浏览器设置的方式拒绝接受cookies。但如果您选择拒绝接受cookies,则您可能无法使用依赖于cookies的优我科华服务或功能。</p>
          <p class="text">（3） 通过优我科华所设cookies所取得的有关信息，将适用本政策。</p>
        </div>
      </div>
    </div>
    <Footer/>
    <Top/>
  </div>
</template>

<script>
import Header from '@/components/Header/index.vue'
import Footer from '@/components/Footer/index.vue'
import Top from '@/components/Top/index.vue'

export default {
  components: {'Header': Header, 'Footer': Footer, 'Top': Top},
  data() {
    return {
      ad5: false,
      ad6: false,
      ad7: false,
      ad8: false
    }
  },
  mounted() {
    window.scrollTo(0, 0)
  },
}

</script>
<style lang='scss' scoped>
$active: #13c2c2;
$width: 1200px;
$banner-height: 632px;
$font: 14px;
$trans: 0.25;
$opacity: 0.85;
$time-height: 110px;

#contact-us {
  padding: 120px 0px;

  .us-content {
    width: $width;
    margin: 0 auto;

    .us-list {
      margin-top: 60px;

      p {
        font-size: 16px;
        color: rgba(0, 0, 0, 0.85);
        line-height: 30px;
      }

      .title {
        font-weight: 600;
      }

      .text {
        margin-bottom: 36px;
      }

      .title-text {
        margin-bottom: 48px;
      }

      .text-item {
        margin: 8px 0px;
      }

      .email-msg {
        opacity: 0.65;
      }

      .email-img {
        margin: 6px 0px;
      }
    }
  }
}

#banner {
  width: 100%;

  img {
    width: 100%;
    display: block;
  }
}

.title-content {
  text-align: center;

  .title {
    font-size: 30px;
    height: 36px;
    line-height: 36px;
  }

  .icon {
    margin: 10px auto;
    height: 2px;
    width: 24px;
    background: $active;
  }

  .trans {
    font-size: $font;
    opacity: $trans;
  }
}
</style>
